<template>
  <vc-date-picker class="inline-block"
                  v-model="date"
                  :masks="masks"
                  :disabled="readonly"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :locale="getLocale"
                  @dayclick="updateDate" >
    <template v-slot="{ inputValue, togglePopover }">
      <div class="flex items-center relative">
        <vs-input class="vsinput w-full" :value="inputValue" @click="!readonly ? togglePopover({ placement: 'auto-start' }) : temp()" readonly :placeholder="placeholder" :class="readonly || 'none-readonly-input'" />
        <vs-icon
          v-if="!readonly && !inputValue"
          icon-pack="feather"
          icon="icon-calendar"
          style="margin-top: 6px; margin-bottom: 6px; margin-right: 1px; padding-left: 6px; padding-right: 6px; position: absolute; top: 0; right: 0; bottom: 0; font-size: 24px; border-left: 1px solid #cdcdcd; background-color: #fff"
          class="cursor-pointer"
          @click="!readonly ? togglePopover({ placement: 'auto-start' }) : temp()"
        ></vs-icon>
        <vs-icon
          v-if="!readonly && inputValue"
          icon-pack="feather"
          icon="icon-x"
          style="margin-top: 6px; margin-bottom: 6px; margin-right: 1px; padding-left: 6px; padding-right: 6px; position: absolute; top: 0; right: 0; bottom: 0; font-size: 24px; border-left: 1px solid #cdcdcd; background-color: #fff"
          class="cursor-pointer"
          @click="!readonly && clickXIcon()"
        ></vs-icon>
      </div>
    </template>
  </vc-date-picker>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";

export default {
  name: "DateSelector",
  components: {
    Datepicker,
  },
  props: {
    value: { type: String, default: "" },
    division: { type: String, default: "-" },
    format: { type: String, default: "YYYY-MM-DD" },
    minimumView: { type: String, default: "day" },
    maximumView: { type: String, default: "year" },
    minDate: { type: String, default: "" },
    maxDate: { type: String, default: "" },
    readonly: Boolean,
    placeholder: String,
  },
  watch: {
    value(data) {
      if (data) {
        this.date = new Date(data);
      } else {
        this.date = "";
      }
    },
  },
  data() {
    return {
      languages: lang,
      date: "",
      masks: {
        input: this.format,
      },
    };
  },

  created() {
    this.date = new Date(this.value);
    this.div = this.division;
  },

  methods: {
    updateDate(data) {
      this.$emit("input", new Date(this.date).format("yyyy-MM-dd"));
      this.$emit("change", this.date);
    },
    temp() {},
    clickXIcon() {
      this.date = "";
      this.$emit("input", "");
      this.$emit("change", "");
    }
  },

  computed: {
    getLocale() {
      let locale = 'ko'
      if (this.$i18n && this.$i18n.locale) {
        locale = this.$i18n.locale.split('_')[0];
      }

      // 번역되지 않는 코드
      const unsupportedLocales = ['km', 'ky', 'lo', 'mn', 'my', 'ne', 'si', 'tk'];
      if (unsupportedLocales.includes(locale)) {
        locale = 'en';
      }

      console.log('locale', locale)
      return locale
    },
  },
};
</script>

<style lang="scss" scoped>
.right-icon {
  font-size: 24px;
  padding: 6px;
}
.none-readonly-input::v-deep {
  input {
    background: white;
  }
}

.datePicker::v-deep {
  .vc-popover-content-wrapper.is-interactive {
    z-index: 999;
  }
}
</style>

<style>
.vc-popover-content-wrapper.is-interactive {
  z-index: 999 !important;
}
</style>
